var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22 0.345C0.458 1.065 0 2.205 0 3.705V50.295C0 51.795 0.458 52.935 1.22 53.655L1.37 53.79L27.47 27.69V27V26.31L1.37 0.21L1.22 0.345Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.16 36.39L27.47 27.69V27V26.31L36.17 17.61L36.35 17.715L46.58 23.49C49.5 25.14 49.5 27.86 46.58 29.52L36.35 35.295L36.16 36.39Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.35 35.285L27.47 27L1.22 53.655C2.23 54.735 3.89 54.87 5.75 53.82L36.35 35.285Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.35 18.715L5.75 0.18C3.89-0.87 2.23-0.735 1.22 0.345L27.47 27L36.35 18.715Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.2f2d9b608dd8cf23018d6953db48770a.svg";
export { ForwardRef as ReactComponent };